import isNil from "lodash/fp/isNil";

class Controller {
  constructor(Events, $stateParams, $injector, Sections, Lists) {
    "ngInject";

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.Lists = Lists;
    this.Events = Events;
    this.$stateParams = $stateParams;
    this.sortEvent = Events.getSortEvent("distpatchers");
    this.paginateEvent = Events.getPaginateEvent("distpatchers");
    this.sections = Sections.settingsSections;
    this.activeParams = this.$stateParams;
    this.filterEvent = this.Events.getFilterEvent("dispatchers");

    // Get ride category per city
    this.City = $injector.get("City");
    this.CityHandler = $injector.get("CityHandler");
    this.dashboardCity = this.CityHandler.get();

    this.getRideCategoriesEvent = this.Events.getUpdateEvent(
      "getRideCategories"
    );
    this.dynamicFiltersEvents = [this.getRideCategoriesEvent];
  }

  $onInit() {
    this.getRideCategory(this.dashboardCity);
  }

  getRideCategory(city) {
    const param = {};
    if (!isNil(city)) {
      param.city = city._id;
    }
    this.Lists.all.rideCategoryList = [];
    this.City.getRideCategory(param).$promise.then((response) => {
      if (response.hits) {
        this.Lists.all.rideCategoryList = response.hits.map(
          ({ _id: name, _source: category }) => ({
            name,
            title: `${category.ride_type} ${category.service_type}`,
            param: "category",
          })
        );
      }
      this.Events.emit(this.getRideCategoriesEvent);
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/dispatchers/dispatchers.controller.js